export function InvalidCodePage() {
    return (
        <div className="account-creation-failure centered-grid">
            <h1>Oops something went wrong!</h1>
            <p>This verification link has expired. Please try resetting your password or contact support for help</p>
        </div>
    );
}